export const profileKeys = {
  all: ["profile"] as const,
  reportStats: () => [...profileKeys.all, "report-stats"] as const,
};
